import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { formatMoney, toShamsi } from '../utils/api';

export default function SaleDetail() {
  const { id } = useParams();
  const [sale, setSale] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get(`/sales/${id}`).then(r => setSale(r.data)); }, [id]);

  const handlePrint = () => window.print();

  if (!sale) return <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>در حال بارگذاری...</div>;

  return (
    <div>
      <div className="page-header no-print">
        <h1>📄 جزئیات فاکتور</h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-outline" onClick={() => navigate('/sales')}>← برگشت</button>
          <button className="btn btn-primary" onClick={handlePrint}>🖨️ چاپ فاکتور</button>
        </div>
      </div>

      {/* فاکتور قابل چاپ */}
      <div className="card" id="invoice" style={{ maxWidth: 750, margin: '0 auto' }}>
        {/* هدر فاکتور */}
        <div style={{ textAlign: 'center', borderBottom: '2px solid var(--border)', paddingBottom: 20, marginBottom: 20 }}>
          <h2 style={{ fontSize: 22, color: 'var(--primary)', marginBottom: 4 }}>🌾 فروشگاه مواد خوارکی محمدی</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>فاکتور فروش</p>
        </div>

        {/* اطلاعات فاکتور */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>شماره فاکتور:</p>
            <p style={{ fontWeight: 700, fontFamily: 'monospace' }}>{sale.invoice_number}</p>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 6, marginTop: 12 }}>تاریخ:</p>
            <p style={{ fontWeight: 500 }}>{toShamsi(sale.sale_date)}</p>
            {sale.dollar_rate && <>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 6, marginTop: 12 }}>نرخ دلار:</p>
              <p style={{ fontWeight: 500 }}>{Number(sale.dollar_rate).toLocaleString('fa')} افغانی</p>
            </>}
          </div>
          <div>
            {sale.first_name ? <>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>مشتری:</p>
              <p style={{ fontWeight: 600, fontSize: 16 }}>{sale.first_name} {sale.last_name}</p>
              {sale.phone && <p style={{ fontSize: 13, marginTop: 4 }}>📞 {sale.phone}</p>}
              {sale.address && <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>📍 {sale.address}</p>}
            </> : <p style={{ color: 'var(--text-muted)' }}>فروش نقدی</p>}
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 6, marginTop: 12 }}>فروشنده:</p>
            <p style={{ fontWeight: 500 }}>{sale.seller_name}</p>
          </div>
        </div>

        {/* آیتم‌های فاکتور */}
        <div className="table-wrap">
          <table style={{ marginBottom: 20 }}>
            <thead>
              <tr><th>#</th><th>محصول</th><th>واحد</th><th>مقدار</th><th>قیمت فی واحد</th><th>جمع</th></tr>
            </thead>
            <tbody>
              {sale.items?.map((item, i) => (
                <tr key={item.id}>
                  <td style={{ color: 'var(--text-muted)' }}>{i + 1}</td>
                  <td style={{ fontWeight: 500 }}>{item.product_name}</td>
                  <td>{item.unit}</td>
                  <td>{Number(item.quantity).toLocaleString('fa')}</td>
                  <td>{formatMoney(item.price_per_unit)}</td>
                  <td style={{ fontWeight: 600 }}>{formatMoney(item.total_price)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* جمع‌بندی مالی */}
        <div style={{ background: 'var(--bg)', borderRadius: 10, padding: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <span style={{ color: 'var(--text-muted)' }}>مجموع فروش:</span>
            <strong style={{ fontSize: 18 }}>{formatMoney(sale.total_amount)}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <span style={{ color: 'var(--success)' }}>پرداخت شده:</span>
            <span style={{ color: 'var(--success)', fontWeight: 600 }}>{formatMoney(sale.paid_amount)}</span>
          </div>
          <div style={{ borderTop: '2px solid var(--border)', paddingTop: 12, display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontWeight: 700, fontSize: 16 }}>
              {Number(sale.debt_amount) > 0 ? '💳 باقی وام:' : '✅ تسویه کامل'}
            </span>
            {Number(sale.debt_amount) > 0 && (
              <strong style={{ color: 'var(--danger)', fontSize: 18 }}>{formatMoney(sale.debt_amount)}</strong>
            )}
          </div>
          {sale.dollar_rate && Number(sale.total_amount) > 0 && (
            <div style={{ marginTop: 10, fontSize: 12, color: 'var(--text-muted)', textAlign: 'left' }}>
              ≈ ${(Number(sale.total_amount) / Number(sale.dollar_rate)).toFixed(2)} USD
            </div>
          )}
        </div>

        {sale.note && (
          <div style={{ marginTop: 16, padding: 12, background: '#fffde7', borderRadius: 8, fontSize: 13 }}>
            📝 یادداشت: {sale.note}
          </div>
        )}

        {/* امضا */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40, marginTop: 40, paddingTop: 20, borderTop: '1px dashed var(--border)' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 8, marginTop: 40, fontSize: 12, color: 'var(--text-muted)' }}>امضای مشتری</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 8, marginTop: 40, fontSize: 12, color: 'var(--text-muted)' }}>امضای فروشنده</div>
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          aside, nav { display: none !important; }
          main { margin: 0 !important; padding: 0 !important; }
          #invoice { box-shadow: none !important; border: none !important; max-width: 100% !important; }
        }
      `}</style>
    </div>
  );
}
